import { Component, OnInit } from '@angular/core';

import { AuthService } from './auth.service';

@Component({
  template: ''
})
export class OauthCallbackComponent implements OnInit {
  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.authService.proccessOauthCallback();
  }
}



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/authentication/oauth-callback.component.ts